import React, { useEffect, useState, memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Box } from '@mui/material';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { TEXTFIELDMATRIX } from '@/constants';

import {
  AccordionStyled,
  AccordionHeaderColors,
  ApplyButton,
  BottomWrapper,
  ButtonWrapper,
  GridContainer,
  Icon,
  ScrollableContainer,
  TitleStyled
} from './styles';

const getAccordionStyle = (props) => {
  const { expand, onTabApplyClick, isGrey } = props;

  if (expand) {
    if (onTabApplyClick) {
      return { display: 'grid', height: 'auto', overflowY: 'hidden', marginBottom: '20px', gridTemplateRows: '90px 1fr 100px' };
    } else if (isGrey) {
      return { display: 'grid', height: 'auto', overflowY: 'hidden', marginBottom: '20px', gridTemplateRows: '90px 1fr' };
    }
    return { flexGrow: 1, maxHeight: '100%', overflowY: 'auto', marginBottom: '20px' };
  }
  return {};
};

const Expandable = props => {
  const {
    id,
    defaultMessage,
    translatedMessageID,
    expanded = true,
    visible = true,
    children = null,
    isGrey = false,
    icon = null,
    handleUpdateExpandableStates = null,
    handleSwitchExpandable = null,
    onTabApplyClick = null,
    scrollable = false,
  } = props;

  const [expand, setExpand] = useState(false);

  useEffect(() => {
    setExpand(expanded);
  }, [expanded]);

  const toggleAcordion = () => {
    const newState = !expand;
    if (handleSwitchExpandable) {
      handleSwitchExpandable(newState ? id : null);
    }
    if (!!handleUpdateExpandableStates) {
      handleUpdateExpandableStates(id, newState);
    }
    setExpand(newState);
  };

  if (visible && children) {
    if (id === TEXTFIELDMATRIX) {
      return (
        <GridContainer id={id} $expanded={expand} $isGrey>
          <AccordionStyled
            style={{ display: 'grid', height: 'auto', overflowY: 'hidden', marginBottom: '20px', gridTemplateRows: '1fr 100px' }}
            className="AccordionGrey"
            expanded={expand}
            $scrollable={scrollable}
            $isGrey={isGrey}
          >
            <Box sx={{ padding: '30px 20px 0px', height: '100%', overflow: 'auto' }}>{children}</Box>
            <BottomWrapper>
              <ButtonWrapper>
                <ApplyButton data-value="apply" onClick={onTabApplyClick}>
                  <FormattedMessage id="app.footer.button.apply" defaultMessage="APPLY" />
                </ApplyButton>
              </ButtonWrapper>
            </BottomWrapper>
          </AccordionStyled>
        </GridContainer>
      );
    }

    return (
      <>
        <GridContainer id={id} key="shapeOptionsControlTools-grid" $isGrey={isGrey} $expanded={expand}>
          <AccordionStyled
            style={getAccordionStyle({ expand, onTabApplyClick, isGrey })}
            className={isGrey ? 'AccordionGrey' : 'Accordion'}
            expanded={expand}
            $scrollable={scrollable}
            $isGrey={isGrey}
          >
            <AccordionHeaderColors $isGrey={isGrey} $expanded={expanded}>
              <AccordionSummary expandIcon={<div><ExpandMoreIcon /></div>} onClick={toggleAcordion}>
                <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, max-content)', alignItems: 'center', gap: '25px' }}>
                  {icon && <Icon src={icon} />}
                  <TitleStyled>
                    <FormattedMessage id={translatedMessageID} defaultMessage={defaultMessage} />
                  </TitleStyled>
                </Box>
              </AccordionSummary>
            </AccordionHeaderColors>
            <AccordionDetails className={isGrey ? 'AccordionDetailsGrey' : 'AccordionDetails'}>
              {isGrey ? <ScrollableContainer>{children}</ScrollableContainer> : <GridContainer>{children}</GridContainer>}
            </AccordionDetails>
            {expand && !!onTabApplyClick && (
              <BottomWrapper>
                <ButtonWrapper>
                  <ApplyButton data-value="apply" disabled={!onTabApplyClick} onClick={onTabApplyClick}>
                    <FormattedMessage id="app.footer.button.apply" defaultMessage="APPLY" />
                  </ApplyButton>
                </ButtonWrapper>
              </BottomWrapper>
            )}
          </AccordionStyled>
        </GridContainer>
      </>
    );
  }

  return null;
};

export default memo(Expandable);
